import { render } from "./LoginYandex.vue?vue&type=template&id=9f363c30&ts=true"
import script from "./LoginYandex.vue?vue&type=script&lang=ts"
export * from "./LoginYandex.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__